module.exports = __webpack_public_path__ + "img/wx_download_tip.41b98a16.png";